import { common } from '../../../common';
import { AttributeBaseModel } from './AttributeBaseModel';
export class ECPointAttributeModel extends AttributeBaseModel {
    constructor({ usage, value }) {
        super();
        this.usage = usage;
        this.value = value;
    }
    serializeWireBase(writer) {
        super.serializeWireBase(writer);
        writer.writeBytes(common.ecPointToBuffer(this.value).slice(1));
    }
}

//# sourceMappingURL=ECPointAttributeModel.js.map
